import { render, staticRenderFns } from "./NewMailInterface.vue?vue&type=template&id=7224d4f3&scoped=true"
import script from "./NewMailInterface.vue?vue&type=script&lang=js"
export * from "./NewMailInterface.vue?vue&type=script&lang=js"
import style0 from "./NewMailInterface.vue?vue&type=style&index=0&id=7224d4f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7224d4f3",
  null
  
)

export default component.exports